<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h2 class="title_h">Quản lý tài khoản ( MA )</h2>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.masterName"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên thương hiệu"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian chăm sóc cuối
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.merchantOwnerId"
              :options="mcOwnerOptions"
              :settings="ownerSettings"
              placeholder="MO"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.businessRegionCode"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.businessProvinceCode"
              :options="dataProvince"
              :disabled="!filters.businessRegionCode || filters.businessRegionCode === '0'"
              placeholder="Tỉnh/Thành phố kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.managerStaffId" :options="listUser" placeholder="Quản lý" />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.staffId"
              :options="listUser"
              placeholder="Nhân viên chăm sóc"
              @change="checkStaff"
            />
          </div>
          <!-- <div class="form-group">
            <Select2 v-model="filters.assignState" :options="assignStateOptions" placeholder="Tình trạng gán NVCS" />
          </div> -->
          <div class="form-group">
            <Select2
              v-model="filters.typeConfigStaff"
              :options="optionsTypeStaff"
              :disabled="changeStaff"
              placeholder="Loại nhân viên"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.typeAssign"
              :options="optionsTypeAssign"
              placeholder="Trạng thái gán"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.type_ma" :options="optionsMa" placeholder="Loại MC" />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.mcLvl" :options="listMcType" placeholder="Cấp bậc merchant" />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.regionCode"
              :options="dataConfigRegion"
              @change="queryMcProvince($event)"
              placeholder="Vùng merchant"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.provinceCode"
              :options="dataProvinceMC"
              placeholder="Tỉnh/Thành phố merchant"
              :disabled="!filters.regionCode || filters.regionCode === '0'"
              @change="getMcDistrict($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.districtCode"
              :options="dataDistrict"
              placeholder="Quận/Huyện merchant"
              :disabled="!filters.provinceCode || filters.provinceCode === '0'"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.mainBusinessMcc"
              :options="dataConfigMcc"
              placeholder="Ngành nghề"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.ownershipType"
              :options="ownershipType"
              placeholder="Loại hình sở hữu"
            />
          </div>
          <!-- <div class="form-group">
            <Select2 v-model="filters.assignState"
              :options="[{ id: 0, text: 'Tất cả' }, { id: 1, text: 'Đã gán' }, { id: 2, text: 'Chưa gán' }]"
              placeholder="Tình trạng gán NVCS" />
          </div> -->

          <div class="form-group">
            <Select2 v-model="filters.status" :options="listMcStatus" placeholder="Trạng thái MA" />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.vaMode"
              :options="[
                { id: '0', text: 'Tất cả' },
                { id: 'VAMC', text: 'VA trực tiếp' },
                { id: 'VANP', text: 'VA gián tiếp' },
              ]"
              placeholder="VA mode"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.mcNewTPV"
              :options="dataMcNewTpv"
              placeholder="Khách hàng TPV mới"
            />
          </div>

          <div class="form-group">
            <Select2
              v-model="filters.hasBusinessRegistrationNumber"
              :options="listhasBusinessRegistrationNumber"
              placeholder="Đăng ký kinh doanh"
            />
          </div>

          <div class="form-group form-group-action">
            <button
              type="submit"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
            <button
              v-if="hasAssignPermission"
              type="button"
              @click="onAssignHandle"
              class="btn btn-outline-info mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Tạo phiếu gán"
              :disabled="!hasCheckeds"
            >
              <span>&nbsp;</span>Tạo phiếu gán
            </button>
            <button
              v-if="hasAssignImportPermission"
              type="button"
              @click="onAssignHandleFile"
              class="btn btn-outline-info mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Tạo phiếu gán"
            >
              <span>&nbsp;</span>Gán bằng file
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div class="box-header">
                <TotalCount :totals="totalCount" :data="totals" />
              </div>
              <div
                v-show="idsSelected.length"
                @click="onClearSelect"
                class="text-nowrap ml-auto text-primary cursor-pointer clean-select"
                v-b-tooltip.hover
                :title="`Click để bỏ chọn, chọn tối đa ${maxtSelect}`"
              >
                Đã chọn:
                <strong class="text-danger">{{
                  idsSelected.length.toLocaleString('vi-VN')
                }}</strong>
              </div>
            </div>
            <b-table
              hover
              sticky-header
              head-variant="light"
              responsive
              :items="dataTable"
              :fields="fields"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>

              <template #head(checkbox)>
                <b-form-checkbox
                  v-model="selectAll"
                  @change="toggleSelectAll"
                  :disabled="isLoading"
                />
              </template>
              <template #cell(checkbox)="{ item }">
                <b-form-checkbox v-model="item.checked" @change="toggleSelectOne(item)" />
              </template>

              <template #cell(owner)="{ item }">
                <div>
                  <b-link :href="`/list-mc/${item.customerId}`" size="sm" target="_blank">
                    {{ item.accountName || '' }}
                  </b-link>
                </div>
                <div>
                  <a :href="`mailto:${item.email}`">{{ item.email }}</a>
                </div>
                <div>{{ item.businessRegistrationAddress }}</div>
                <div v-show="item?.businessRegistrationNumber">
                  <strong><span style="color: #de0000">GPĐKKD</span>:</strong>
                  {{ item.businessRegistrationNumber }}
                </div>
              </template>

              <template #cell(staff)="{ item }">
                <div v-if="getMainStaff(item)">
                  <span class="text-muted">Chính</span>:
                  <b-link :href="`/staff/detail/?id=${getMainStaff(item).staffId}`" target="_blank">
                    {{ getMainStaff(item).staffName }}</b-link
                  >
                </div>
                <div v-if="getSecondStaff(item)">
                  <span class="text-muted">Phụ</span>:
                  <span v-for="(staff, index) in getSecondStaffArr(item)" :key="staff.staffId">
                    <a
                      v-if="index < 3"
                      style="cursor: pointer"
                      :href="`/staff/detail/?id=${staff.staffId}`"
                      target="_blank"
                    >
                      {{
                        `${staff.staffName}${index < getSecondStaffArr(item).length - 1 ? '; ' : ''}`
                      }}
                    </a>
                  </span>
                  <span
                    v-if="remainingCount(getSecondStaff(item))"
                    v-b-tooltip.hover="{ customClass: 'tooltip-class' }"
                    v-b-tooltip.hover.html="tooltipContent(item)"
                    style="cursor: pointer"
                  >
                    ...{{ remainingCount(getSecondStaff(item)) }}
                  </span>
                </div>
              </template>

              <template #cell(merchantLevel)="{ item }">
                <p>
                  <span @click="searchMerchantLevel(item)" style="cursor: pointer">{{
                    getMerchantLevelName(item.merchantLevel)
                  }}</span>
                </p>
                <p v-if="item.referSource">
                  <span class="text-muted">Nguồn:</span>
                  {{ item.referSource ? item.referSource : '' }}
                </p>
              </template>

              <template #cell(merchantOwner)="{ item }">
                <a
                  :href="'/customer-support/merchant-owner/' + item?.merchantOwner?.id"
                  target="_blank"
                >
                  <span class="text-muted"
                    >Tên:
                    <span style="color: #319db5">{{
                      item.merchantOwner?.ownerName || ''
                    }}</span></span
                  >
                </a>
              </template>

              <template #cell(ownershipType)="{ item }">
                <p>
                  <span @click="searchOwnershipType(item)" style="cursor: pointer">{{
                    getOwnershipTypeName(item.ownershipType)
                  }}</span>
                </p>

                <p :class="item?.hasBusinessRegistrationNumber ? 'text-success' : 'text-danger'">
                  {{ item?.hasBusinessRegistrationNumber ? 'Có ĐKKD' : 'Không ĐKKD' }}
                </p>
              </template>

              <template #cell(businessType)="{ item }">
                <p>
                  <span @click="searchBusinessType(item)" style="cursor: pointer">{{
                    getBusinessTypeName(item.mainBusinessMcc)
                  }}</span>
                </p>
              </template>
              <template #cell(vaMode)="{ item }">
                {{ item?.vaMode === 'VAMC?' ? 'Có' : 'Không' }}
              </template>
              <template #cell(times)="{ item }">
                <div v-if="item.dateSign" class="nowrap">
                  <span class="text-muted">Tạo</span>:
                  {{ item.dateSign | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
                <div v-if="item.createdDate" class="nowrap">
                  <span class="text-muted">Đồng bộ</span>:
                  {{ item.createdDate | formatDate }}
                </div>
                <div v-if="item.activedDate" class="nowrap">
                  <span class="text-muted">Kích hoạt</span>:
                  {{ item.activedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
                <div v-if="item.lockedDate" class="nowrap">
                  <span class="text-muted">Khóa</span>:
                  {{ item.lockedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
              </template>
              <template #cell(serviceCare)="{ item }">
                <div v-if="item?.serviceCare?.completionTime" class="nowrap">
                  {{ item.serviceCare?.completionTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </div>
              </template>

              <template #cell(status)="{ item }">
                <div class="text-center">
                  <span :class="`badge ${getStatusClass(item.status)}`">
                    {{ getStatusName(item.status) }}
                  </span>
                </div>
              </template>

              <template #cell(typeSconMa)="{ item }">
                <div class="text-center">
                  <span>
                    {{ getStatusNameMC(item.typeSconMa) }}
                  </span>
                </div>
              </template>

              <template #cell(actions)="{ item }">
                <div>
                  <b-link :href="`/customer-support/account/${item.id}`" size="sm" target="_blank"
                    >Chi tiết</b-link
                  >
                </div>
                <div>
                  <b-link
                    :href="`/customer-support/account/${item.id}/history-assign`"
                    size="sm"
                    target="_blank"
                    >Lịch sử gán CS</b-link
                  >
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-form-group class="mb-0" style="padding: 17px">
                <b-form-select
                  v-model="pagination.limit"
                  :options="pageOptions"
                  @change="onItemsPerPageChange"
                ></b-form-select>
              </b-form-group>
              <b-pagination
                v-model="pagination.page"
                :total-rows="totalCount"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
      <PopupEdit ref="popupEditRef" @update-table="refreshTable" />
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'
  import { CommonService } from '@/services/common.service'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import { SearchByCode } from '@/services/customer-support/location'
  import { showMess } from '@/config/utils'
  import PopupEdit from './components/PopupEdit.vue'
  import { List as OwnerList } from '@/services/customer-support/merchant-owner'

  // import moment from 'moment'
  // import { level3LocationDetails } from '@/config/manhthdConfigs'
  // import DateRangePicker from 'vue2-daterange-picker'
  // import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import TotalCount from '@/components/cskh/Counts.vue'
  import gzip from 'gzip-js'
  import { Search } from '../../../../services/customer-support/account'
  import moment from 'moment'

  const maxtSelect = 200

  export default {
    components: {
      PopupEdit,
      TotalCount,
    },
    data() {
      return {
        filters: {
          textSearch: '',
          mcLvl: '',
          regionCode: '',
          provinceCode: '',
          districtCode: '',
          businessRegionCode: '',
          businessProvinceCode: '',
          managerStaffId: '',
          staffId: '',
          typeAssign: '',
          mainBusinessMcc: '',
          ownershipType: '',
          assignState: '',
          status: '',
          typeConfigStaff: '',
        },
        isLoading: true,
        selectAll: false,
        dataConfigRegion: [],
        dataProvince: [],
        dataConfigRegionMC: [],
        dataProvinceMC: [],
        dataDistrict: [],
        dataConfigMcc: [],
        dataManager: [],
        listUser: [],
        listStateSearch: [],
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        optionsTypeAssign: [],
        optionsMa: [
          { id: 0, text: 'Tất cả' },
          { id: 'MA_THE', text: 'MC thẻ' },
          { id: 'ONBOARD_QR', text: 'MC chỉ dùng QR' },
          { id: 'MA_ORTHER', text: 'MC khác' },
        ],

        optionsTypeStaff: [
          { id: 0, text: 'Tất cả' },
          { id: 'MAIN', text: 'Chính' },
          { id: 'SECOND', text: 'Phụ' },
        ],
        mcOwnerOptions: [],
        ownerSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                OwnerList({
                  limit: 10,
                  page: 1,
                  keyWord: keySearch,
                  sort: {
                    direction: 'DESC',
                    properties: ['createdDate'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.list?.map(item => {
                          return {
                            id: item?.id,
                            text: (item?.ownerName || item?.masterName) ?? item?.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        // config
        dataConfigService: [],
        sourceCreate: Config.sourceCreate,
        localeData: Config.localeData,
        ownershipType: [], // systemConfig.ownershipType,

        listMcType: [
          { id: 0, text: 'Tất cả' },
          {
            id: 'MC_KEY',
            text: 'Merchant key',
          },
          {
            id: 'MC_NORMAL',
            text: 'Merchant thường',
          },
        ],

        listhasBusinessRegistrationNumber: [
          { id: 0, text: 'Tất cả' },
          { id: true, text: 'Có ĐKKD' },
          {
            id: false,
            text: 'Không ĐKKD',
          },
        ],
        // assignStateOptions: [
        //   { id: 0, text: 'Tất cả' },
        //   { id: 1, text: 'Đã gán chính' },
        //   { id: 3, text: 'Đã gán phụ' },
        //   { id: 2, text: 'Chưa gán' }
        // ],
        listMcStatus: [
          //   { id: 0, text: 'Tất cả' },
          //   { id: 'ACTIVE', text: 'Đang hoạt động', bgColor: 'badge-success', class: 'text-success' },
          //   { id: 'DENIED', text: 'Bị từ chối', bgColor: 'badge-danger', class: 'text-danger' },
          //   { id: 'SUSPENDED', text: 'Đang khóa', bgColor: 'badge-danger', class: 'text-danger' },
          //   { id: 'PENDING_CONFIRM_APPROVAL', text: 'Chờ Bank thẩm định', bgColor: 'badge-primary', class: 'text-primary' },
          //   { id: 'PENDING_APPROVAL', text: 'Chờ MPOS thẩm định', bgColor: 'badge-warning', class: 'text-warning' },
          //   { id: 'PENDING_INFORMATION', text: 'Chưa thiết lập thông tin', bgColor: 'badge-info', class: 'text-info' },
          //   { id: 'UNDEFINED', text: 'Không xác định', bgColor: 'badge-secondary', class: 'text-secondary' },
        ],
        totalCount: 0,
        fields: [
          {
            key: 'owner',
            label: 'Tài khoản',
            sortable: false,
            thStyle: 'min-width: 150px, max-width: 200px',
            tdClass: 'td_class',
          },
          {
            key: 'merchantOwner',
            label: 'Thông tin MO',
            sortable: false,
            thStyle: 'min-width: 150px',
          },
          {
            key: 'businessType',
            label: 'Ngành nghề',
            sortable: false,
          },
          {
            key: 'merchantLevel',
            label: 'Cấp bậc merchant/Nguồn',
            sortable: false,
          },
          {
            key: 'ownershipType',
            label: 'Loại hình sở hữu',
            sortable: false,
          },
          {
            key: 'times',
            label: 'Thời gian',
            sortable: false,
            tdClass: 'time_class nowrap',
          },
          {
            key: 'staff',
            label: 'NV chăm sóc',
            sortable: false,
            thStyle: 'min-width: 150px, max-width: 200px',
            tdClass: 'td_class',
          },
          {
            key: 'status',
            label: 'Trạng thái',
            sortable: false,
            thStyle: 'min-width: 80px',
          },
          {
            key: 'typeSconMa',
            label: 'Loại MC',
            sortable: false,
            thStyle: 'min-width: 80px',
          },

          {
            key: 'serviceCare',
            label: 'Thời gian chăm sóc cuối',
            sortable: false,
            thStyle: 'min-width: 80px',
          },

          {
            key: 'vaMode',
            label: 'ĐK VA Bank trực tiếp',
            sortable: false,
            thStyle: 'min-width: 80px',
          },
          {
            key: 'actions',
            label: 'Thao tác',
            sortable: false,
            thStyle: 'min-width: 80px',
          },
        ],
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        totals: [],
        dataTable: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],

        // multiple select row
        idsSelected: [],
        maxtSelect,
        dataMcNewTpv: [
          { id: 0, text: 'Tất cả' },
          { id: 'true', text: 'Khách hàng mới' },
          { id: 'false', text: 'Khách hàng cũ' },
        ],
      }
    },
    filters: {
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    created() {
      const queries = this.$router.currentRoute.query
      if (queries.moId && queries.moName) {
        this.mcOwnerOptions = [
          {
            id: queries.moId,
            text: queries.moName,
          },
        ]
        this.filters.merchantOwnerId = queries.moId
      }
      if (this.hasAssignPermission) {
        this.fields.unshift({
          key: 'checkbox',
          label: '',
          sortable: false,
          thStyle: 'width: 30px; text-align: center',
        })
      }
    },
    async mounted() {
      await this.configSystem()
      if (this.dataPermission.includes('CNPS_CSS_MA_LIST')) {
        await this.getRegions()
        await this.getManager()
        await this.getListStaffBySuperior()
        await this.buildQuery()
        await this.getMcRegions()
        // await this.getMcDistrict()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      hasAssignPermission() {
        return this.dataPermission.includes('CNPS_CSS_ASSIGN_ORDER_CREATE')
      },
      hasAssignImportPermission() {
        return this.dataPermission.includes('CNPS_CSS_STAFF_ASSIGN_IMPORT_FILE')
      },
      getStatusName() {
        return status => {
          const objStatus = this.listMcStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusNameMC() {
        return status => {
          const objStatus = this.optionsMa.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },

      getStatusClass() {
        return status => {
          const objStatus = this.listMcStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
      getBusinessTypeName() {
        return mcc => {
          const objStatus = this.dataConfigMcc.find(s => s.id === mcc)
          return objStatus ? objStatus.text : mcc
        }
      },
      getOwnershipTypeName() {
        return owner => {
          const objStatus = this.ownershipType.find(s => s.id === owner)
          return objStatus ? objStatus.text : owner
        }
      },
      getMerchantLevelName() {
        return lvl => {
          const objStatus = this.listMcType.find(s => s.id === lvl)
          return objStatus ? objStatus.text : lvl
        }
      },
      getMainStaff() {
        return maInfo => {
          return maInfo.staffAssigns && maInfo.staffAssigns.length > 0
            ? maInfo.staffAssigns.find(uInfo => uInfo.configType === 'MAIN')
            : undefined
        }
      },
      getSecondStaff() {
        return maInfo => {
          const usersInfo =
            maInfo.staffAssigns && maInfo.staffAssigns.length > 0
              ? maInfo.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
              : []
          if (usersInfo) {
            return usersInfo
              .reduce((arr, userInfo) => {
                arr.push(userInfo.staffName)
                return arr
              }, [])
              .join(', ')
          }
          return ''
        }
      },

      getSecondStaffArr() {
        return maInfo => {
          return maInfo.staffAssigns && maInfo.staffAssigns.length > 0
            ? maInfo.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
            : []
        }
      },
      truncatedText() {
        return maInfo => {
          const usersInfo =
            maInfo.staffAssigns && maInfo.staffAssigns.length > 0
              ? maInfo.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
              : []
          if (usersInfo) {
            const parts = usersInfo.reduce((arr, userInfo) => {
              arr.push({
                id: userInfo.staffId,
                name: userInfo.staffName,
              })
              return arr
            }, [])
            if (parts.length > 3) {
              return parts
                .slice(0, 3)
                .map(item => {
                  return `<a style="cursor: pointer;" href='/staff/detail/?id=${item.id}' target="_blank">${item.name}</a>`
                })
                .join(', ')
              // return parts.slice(0, 3).join(', ');
            }
            // return maInfo;
            return parts
              .map(item => {
                return `<a style="cursor: pointer;" href='/staff/detail/?id=${item.id}' target="_blank">${item.name}</a>`
              })
              .join(', ')
          }
          return ''
        }
      },
      remainingCount() {
        return maInfo => {
          const parts = maInfo.split(', ')
          if (parts.length > 3) {
            return `+${parts.length - 3}`
          }
          return ''
        }
      },
      tooltipContent() {
        return maInfo => {
          const usersInfo =
            maInfo.staffAssigns && maInfo.staffAssigns.length > 0
              ? maInfo.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
              : []
          if (usersInfo) {
            const parts = usersInfo.reduce((arr, userInfo) => {
              arr.push({
                id: userInfo.staffId,
                name: userInfo.staffName,
              })
              return arr
            }, [])
            if (parts.length > 3) {
              return parts
                .slice(3)
                .map(item => {
                  return `<a style="cursor: pointer;" href='/staff/detail/?id=${item.id}' target="_blank">${item.name}</a>`
                })
                .join('<br>')
            }
          }
          return ''
        }
      },
      hasCheckeds() {
        // return this.dataTable.some(row => row.checked)
        return this.idsSelected.length > 0
      },
      changeStaff() {
        return this.filters.staffId === '0' || !this.filters.staffId
      },
    },
    methods: {
      onItemsPerPageChange() {
        this.pagination.page = 1 // Reset về trang 1 khi thay đổi số mục mỗi trang
        this.refreshTable()
      },
      refreshTable() {
        this.buildQuery()
      },
      // nút bỏ lọc
      async clearSearch() {
        this.selectAll = false
        this.pagination.page = 1
        this.filters = {}
        this.dataProvince = []
        this.dataProvinceMC = []
        this.dataDistrict = []
        // // Xóa query params trên URL
        // await this.$router.replace({
        //   path: this.$route.path,
        //   query: {} // set empty object để xóa hết query
        // })
        await this.buildQuery()
      },
      transformDate() {
        this.filters.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.filters.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      async buildQuery() {
        const conditions = []
        const conditionsMap = {}

        const textSearch = this.filters.textSearch?.trim()
        // thương hiệu
        const textmasterName = this.filters.masterName?.trim()

        const isHasBusinessRegistrationNumber = this.filters.hasBusinessRegistrationNumber

        textSearch && conditions.push(`{textSearch} LIKE '''${textSearch}'''`)
        if (textmasterName) {
          conditionsMap.masterName = textmasterName
        }
        isHasBusinessRegistrationNumber &&
          isHasBusinessRegistrationNumber !== '0' &&
          conditions.push(`{hasBusinessRegistrationNumber} == ${isHasBusinessRegistrationNumber}`)

        this.filters.mcLvl &&
          this.filters.mcLvl !== '0' &&
          conditions.push(`{mcLvl} == '''${this.filters.mcLvl}'''`)

        this.filters.businessRegionCode &&
          this.filters.businessRegionCode !== '0' &&
          (conditionsMap.businessRegionCode = this.filters.businessRegionCode)
        this.filters.businessProvinceCode &&
          this.filters.businessProvinceCode !== '0' &&
          (conditionsMap.businessProvinceCode = this.filters.businessProvinceCode)
        this.filters.typeConfigStaff &&
          this.filters.typeConfigStaff !== '0' &&
          (conditionsMap.typeConfigStaff = this.filters.typeConfigStaff)

        this.filters.managerStaffId &&
          this.filters.managerStaffId !== '0' &&
          (conditionsMap.managerStaffId = this.filters.managerStaffId)
        this.filters.mainBusinessMcc &&
          this.filters.mainBusinessMcc !== '0' &&
          conditions.push(`{mainBusinessMcc} == '''${this.filters.mainBusinessMcc}'''`)
        this.filters.ownershipType &&
          this.filters.ownershipType !== '0' &&
          conditions.push(`{ownershipType} == '''${this.filters.ownershipType}'''`)
        this.dateRange.startDate &&
          this.dateRange.endDate &&
          conditions.push(
            `{serviceCare.completionTime} range [#${moment(this.dateRange.startDate).startOf('day').add(7, 'hours').toISOString()}#, #${moment(this.dateRange.endDate).endOf('day').add(7, 'hours').toISOString()}#]`
          )

        // VA mode
        this.filters.vaMode &&
          this.filters.vaMode !== '0' &&
          conditions.push(`{vaMode} == '''${this.filters.vaMode}'''`)
        // merchant owner
        this.filters.merchantOwnerId &&
          this.filters.merchantOwnerId !== '0' &&
          conditions.push(`{merchantOwnerId} == '''${this.filters.merchantOwnerId}'''`)

        this.filters.assignState && (conditionsMap.assignState = this.filters.assignState)
        this.filters.status &&
          this.filters.status !== '0' &&
          conditions.push(`{merchantMpos.status} == '''${this.filters.status}'''`)
        this.filters.mcNewTPV &&
          this.filters.mcNewTPV !== '0' &&
          conditions.push(`{mcNewTPV} == '''${this.filters.mcNewTPV}'''`)

        this.filters.regionCode &&
          this.filters.regionCode !== '0' &&
          conditions.push(`{regionId} == '''${this.filters.regionCode}'''`)
        this.filters.provinceCode &&
          this.filters.provinceCode !== '0' &&
          conditions.push(`{provinceCode} == '''${this.filters.provinceCode}'''`)
        this.filters.districtCode &&
          this.filters.districtCode !== '0' &&
          conditions.push(`{districtCode} == '''${this.filters.districtCode}'''`)

        if (this.filters.staffId && this.filters.staffId !== '0') {
          conditionsMap.staffId = this.filters.staffId
        }

        this.filters.type_ma &&
          this.filters.type_ma !== '0' &&
          conditions.push(`{type_ma} == '''${this.filters.type_ma}'''`)

        this.filters.typeAssign &&
          this.filters.typeAssign !== '0' &&
          (conditionsMap.typeAssign = this.filters.typeAssign)

        this.pagination.queryString = conditions.join(' AND ')
        await this.loadData(conditionsMap)
        // await this.getCount(conditionsMap);
        // await this.getData(conditionsMap)
      },

      // async getData(conditionsMap = {}) {
      //   const searchQuery = {
      //     limit: this.pagination.limit,
      //     page: this.pagination.page,
      //     queryString: this.pagination.queryString,
      //     ...conditionsMap,
      //     sort: {
      //       direction: this.pagination.sortType,
      //       properties: [this.pagination.sortField],
      //     }
      //   };
      //   try {
      //     this.isLoading = true;
      //     const [resList, resCount] = await Promise.all([
      //       List(searchQuery),
      //       GetCount({
      //         queryString: this.pagination.queryString,
      //         ...conditionsMap,
      //       })
      //     ])
      //     if (resList.result) {
      //       this.dataTable = resList.data.map(el => {
      //         return {
      //           ...el,
      //           checked: false,
      //         }
      //       });
      //       this.pagination.total = resList.total;
      //     }
      //     if (resCount.result) {
      //       this.totals = resCount.data.filter(item => item.status)
      //         .sort((a, b) => a.status.localeCompare(b.status))
      //         .reduce((acc, item) => {
      //           const status = acc.find(s => s.status === item.status);
      //           if (status) {
      //             status.count += item.count;
      //           } else {
      //             const statusObj = this.listMcStatus.find(list => list.id == item.status)
      //             acc.push({ status: statusObj.text, status_class: statusObj.class, count: item.count });
      //           }
      //           return acc;
      //         }, []);
      //       this.totalCount = this.totals
      //         .filter(item => item.status)
      //         .reduce((sum, item) => sum + item.count, 0);
      //     }
      //   } catch (e) {
      //     showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
      //   } finally {
      //     this.isLoading = false;
      //   }
      // },
      // formatDate(date, format = "HH:mm, DD/MM/YYYY") {
      //   if (!date) return
      //   return moment(date).format(format)
      // },

      async loadData(conditionsMap = {}) {
        try {
          this.isLoading = true
          const searchQuery = {
            countStatus: true,
            showStaffAssign: true,
            limit: this.pagination.limit,
            page: this.pagination.page,
            queryString: this.pagination.queryString,
            ...conditionsMap,
            sort: {
              direction: this.pagination.sortType,
              properties: [this.pagination.sortField],
            },
          }
          const res = await Search(searchQuery)
          if (res.data.listData) {
            this.dataTable = res.data.listData.map(el => {
              return {
                ...el,
                checked: this.idsSelected.includes(el.id),
              }
            })
          } else {
            this.dataTable = []
          }
          this.selectAll = false
          this.pagination.total = res.data.totalCount ?? 0
          this.totalCount = res.data.totalCount ?? 0
          if (res.data.listCountStatus) {
            this.totals = res.data.listCountStatus
              .filter(item => item.status)
              .sort((a, b) => a.status.localeCompare(b.status))
              .reduce((acc, item) => {
                const status = acc.find(s => s.status === item.status)
                if (status) {
                  status.count += item.count
                } else {
                  const statusObj = this.listMcStatus.find(list => list.id == item.status)
                  acc.push({
                    status: statusObj?.text || item.status,
                    status_class: statusObj?.class ?? 'text-primary',
                    count: item.count,
                  })
                }
                return acc
              }, [])
          } else {
            this.totals = []
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },

      // async getCount(conditionsMap = {}) {
      //   try {
      //     this.isLoading = true;
      //     const res = await GetCount({
      //       limit: this.pagination.limit,
      //       page: this.pagination.page,
      //       queryString: this.pagination.queryString,
      //       ...conditionsMap,
      //       sort: {
      //         direction: this.pagination.sortType,
      //         properties: [this.pagination.sortField],
      //       }
      //     });
      //     if (res.result) {
      //       // this.totals.suspend = res.data.find(obj => obj.status === 'SUSPENDED')?.count || 0
      //       // this.totals.active = res.data.find(obj => obj.status === 'ACTIVE')?.count || 0

      //       this.totals = res.data.filter(item => item.status)
      //         .sort((a, b) => a.status.localeCompare(b.status))
      //         .reduce((acc, item) => {
      //           const status = acc.find(s => s.status === item.status);
      //           if (status) {
      //             status.count += item.count;
      //           } else {
      //             const statusObj = this.listMcStatus.find(list => list.id == item.status)
      //             acc.push({ status: statusObj.text, status_class: statusObj.class, count: item.count });
      //           }
      //           return acc;
      //         }, []);
      //       this.totalCount = this.totals
      //         .filter(item => item.status)
      //         .reduce((sum, item) => sum + item.count, 0);
      //     }
      //   } catch (e) {
      //     showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
      //   } finally {
      //     this.isLoading = false;
      //   }
      // },

      async submitForm() {
        this.pagination.page = 1
        this.selectAll = false
        this.buildQuery()
      },
      // Cập nhật
      onEditClick(item) {
        this.$refs.popupEditRef.show(item, 'Cập nhật Account')
      },
      // search Ngành nghề
      searchBusinessType(item) {
        this.filters.mainBusinessMcc = item.mainBusinessMcc
      },
      // search Loại hình sở hữu
      searchOwnershipType(item) {
        this.filters.ownershipType = item.ownershipType
      },
      // search Cấp bậc merchant
      searchMerchantLevel(item) {
        this.filters.mcLvl = item.merchantLevel
      },
      // page
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.buildQuery()
      },
      onAssignHandle() {
        const checkedIds = this.idsSelected
        if (checkedIds.length > 0) {
          const gzipData = gzip.zip(checkedIds.join(','), {
            level: 9,
          })
          const encodedString = btoa(String.fromCharCode(...gzipData))
          this.$router.push({
            path: `/customer-support/add-staff/MERCHANT_ACCOUNT`,
            query: { ids: encodedString },
          })
        }
      },
      onAssignHandleFile() {
        this.$router.push({
          path: `/customer-support/add-staff/MERCHANT_ACCOUNT`,
          query: { useFile: true },
        })
      },
      toggleSelectAll() {
        // this.dataTable.forEach(item => {
        //   item.checked = this.selectAll;
        // });
        const value = this.selectAll
        for (const item of this.dataTable) {
          item.checked = value
          const id = item.id
          const index = this.idsSelected.indexOf(id)
          index >= 0 && this.idsSelected.splice(index, 1)
          if (value) {
            !this.idsSelected.includes(id) && this.idsSelected.push(id)
          }
        }
        this.cleanSelectIfOver()
      },
      toggleSelectOne(item) {
        const id = item.id
        const index = this.idsSelected.indexOf(id)
        index >= 0 && this.idsSelected.splice(index, 1)
        if (item.checked) {
          !this.idsSelected.includes(id) && this.idsSelected.push(id)
        }
        this.selectAll = this.dataTable.every(item => item.checked)
        this.cleanSelectIfOver()
      },
      onClearSelect() {
        this.idsSelected = []
        this.selectAll && (this.selectAll = false)
        this.dataTable.forEach(item => {
          item.checked && (item.checked = false)
        })
      },
      cleanSelectIfOver() {
        this.idsSelected.length > maxtSelect &&
          (() => {
            this.idsSelected = this.idsSelected.slice(-maxtSelect)
          })()
      },
      checkStaff() {
        if (this.filters.staffId === '0' || !this.filters.staffId) {
          this.filters.typeConfigStaff = ''
        }
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          this.filters.businessProvinceCode = ''
          this.dataProvince = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy vùng mc
      async getMcRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegionMC = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp mc
      async queryMcProvince(e) {
        try {
          this.filters.provinceCode = ''
          this.filters.districtCode = ''
          this.dataDistrict = []
          this.dataProvinceMC = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvinceMC = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvinceMC.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy quận mc
      async getMcDistrict(event) {
        const data = await SearchByCode({ code: event })
        if (data.data.length > 0) {
          this.dataDistrict = data.data
            .sort((a, b) => a.locationCode.localeCompare(b.locationCode))
            .map(e => {
              return {
                id: e.locationCode,
                text: e.localName,
              }
            })
        }
        // this.dataDistrict = level3LocationDetails.filter(item => item.code.includes(event))
        //   .sort((a, b) => a.code.localeCompare(b.code))
        //   .map(e => {
        //     return {
        //       id: e.code,
        //       text: e.name
        //     }
        //   })
        this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
      },
      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: '63fc2ab0c0eba2668fba9790',
            // userId: this.userId
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.listUser.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // Lấy quản lý
      async getManager() {
        try {
          const data = await StaffService.superiors()
          if (data.success) {
            this.dataManager = data.data.map(e => {
              return {
                id: e.id,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.dataManager.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.ownershipType = data.data.ownershipType.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                }
              })
              this.ownershipType.unshift({ id: '0', text: 'Tất cả' })
              this.dataConfigService = data.data.services.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigService.unshift({ id: '0', text: 'Tất cả' })
              this.getListService()
              this.dataConfigMcc = data.data.businessFields.map(e => {
                return {
                  id: e.code,
                  text: e.name,
                }
              })
              this.dataConfigMcc.unshift({ id: '0', text: 'Tất cả' })
              // this.assignStateOptions = data.data.typeAssign.map((e) => {
              //   return {
              //     id: e.code,
              //     text: e.name
              //   }
              // })
              // this.assignStateOptions.unshift({ id: '0', text: 'Tất cả' })
              this.listMcStatus = data.data.merchantAccountStatus.map(e => {
                return {
                  ...e,
                  id: e.code,
                  text: e.name,
                }
              })
              this.listMcStatus.unshift({ id: '0', text: 'Tất cả' })
              this.optionsTypeAssign = data.data.typeAssign.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                }
              })
            }
          })
          .catch(error => console.error(error))
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              this.dataConfigService = data[0].detail.map(e => {
                return {
                  id: e.code,
                  text: this.serviceTypes(e.name),
                }
              })
            }
            // ListState
            this.listStateSearch = [{ id: 0, text: 'Tất cả' }, ...this.listState]
          }
        } catch (error) {
          console.log(error)
        }
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },
  }
</script>
<style scoped>
  .total_check {
    /* margin: 5px; */
    /* text-align: center; */
    display: flex;
    text-align: center;
  }

  .total_label {
    color: #8a9298;
    font-size: 14px;
  }

  .total_field {
    font-size: 20px;
  }
</style>
<style>
  .td_class {
    min-width: 150px;
    max-width: 200px;
  }

  .time_class {
    min-width: 100px;
    max-width: 200px;
  }

  .nowrap {
    white-space: nowrap;
  }

  .tooltip-class .tooltip-inner {
    background-color: rgb(253, 253, 253);
    color: #319db5;
    text-align: left;
    max-height: 150px;
    max-width: 200px;
    overflow-y: auto;
    border: 1px solid;
  }

  .title_h {
    font-size: 20px;
    font-weight: 400;
    line-height: 23.44px;
    text-align: left;
  }

  .clean-select {
    &:hover {
      text-decoration: line-through;
    }
  }
</style>
